
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { IFreeInputable, IOptionSelectable, TextItemOption } from "../../../../../domain/document/items";

@Component({
})
export default class OptionSelectableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: IOptionSelectable & IFreeInputable) => T, defaultValue: T) => T;
  writePropertyWhenValid: (writer: (source: IOptionSelectable & IFreeInputable) => void) => void;

  get label(): string {
    return this.readPropertyOrDefault(s => s.label, undefined);
  }

  set label(value: string) {
    // writePropertyはまとめて処理.(メインループに戻らずに処理するとvalueの更新通知を受ける前に次の更新をしようとして前の変更が抜けてしまう?)
    this.writePropertyWhenValid(s => {
      if (s.isFreeInputable) {
        // 「全てフリー入力」でフリー入力になっている状態で手入力されたときの対応
        s.shouldInputFree = true;
      }
      s.options = Enumerable.from(this.options)
        .select((o: TextItemOption) => {
          o.isSelected = false;
          return o;
        })
        .toArray();
      s.label = value;
      s.value = value;
      s.score = null;
      s.code = null;
    });
  }

  get options(): TextItemOption[] {
    return this.readPropertyOrDefault(s => s.options, undefined);
  }

  get isOptionSelected(): boolean {
    return (0 <= this.selectedOptionIndex);
  }

  get selectedOption(): TextItemOption {
    return this.isOptionSelected
      ? this.options[this.selectedOptionIndex]
      : null;
  }

  set selectedOption(value: TextItemOption) {
    // writePropertyはまとめて処理.(メインループに戻らずに処理するとvalueの更新通知を受ける前に次の更新をしようとして前の変更が抜けてしまう?)
    this.writePropertyWhenValid(s => {
      s.options = Enumerable.from(this.options)
        .select((o: TextItemOption) => {
          o.isSelected = (o === value);
          return o;
        })
        .toArray();
      if (value) {
        s.applyOptionValue(value);
      }
    });
  }

  get selectedOptionIndex(): number {
    return Enumerable.from(this.options)
      .indexOf((o, i) => o.isSelected);
  }

  set selectedOptionIndex(value: number) {
    this.selectedOption = this.options[value];
  }

  findOptionToSelect(): TextItemOption {
    return !this.selectedOption
      ? Enumerable.from(this.options).firstOrDefault(o => o.text === this.label)
      : this.selectedOption;
  }

  toSelectPrevOption(): void {
    const index = this.selectedOptionIndex - 1;
    if (index >= 0 && index < this.options.length) {
      this.selectedOption = this.options[index];
    }
  }

  toSelectNextOption(): void {
    const index = this.selectedOptionIndex + 1;
    if (index >= 0 && index < this.options.length) {
      this.selectedOption = this.options[index];
    }
  }

  toSelectFirstOption(): void {
    if (this.options.length > 0) {
      this.selectedOption = this.options[0];
    }
  }

  toSelectLastOption(): void {
    if (this.options.length > 0) {
      this.selectedOption = this.options[this.options.length - 1];
    }
  }
}
